import { useTranslation } from 'react-i18next'

import type { LoadStanding } from './api'

/** The chip each standing wears, the posting board's colours: green for open, grey for history. */
const BADGE_BY_STANDING: Readonly<Record<LoadStanding, string>> = {
  Open: 'badge--active',
  Expired: 'badge--inactive',
  Cancelled: 'badge--inactive',
  Discarded: 'badge--inactive',
}

/** Where a load stands — read from text as much as colour, like every chip here. */
export function LoadStandingBadge({ standing }: { standing: LoadStanding }) {
  const { t } = useTranslation()

  return <span className={`badge ${BADGE_BY_STANDING[standing]}`}>{t(`loads.standings.${standing}`)}</span>
}
